import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RightPanelService } from 'src/app/core/services/right-panel.service';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { RightPanelType } from 'src/app/core/enums/right-panel-type.enum';
import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';
import { MessageDTO } from '@sb-tools/typescript/models/dto/message.dto';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TicketService } from 'src/app/core/services/ticket/ticket.service';
import { ForwardMessageService } from '../../../core/services/forward-message.service';
import { ForwardEntityTypeEnum } from '../../../core/enums/forward-entity-type.enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { HideContentPartResponseDTO } from '../../../core/models/dto/hide-content-part-response.dto';
import { DatePipe, NgClass } from '@angular/common';
import { UserAvatarComponent } from '../../../../sb-modules/Frontend-User-Avatar-Module/user-avatar.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { InlineImagePreviewDirective } from '../../../../sb-modules/Frontend-Document-Viewer-Module/directives/inline-image-preview.directive';
import { InlineImageLimitWidthDirective } from '../../../shared/directives/inline-image-limit-width.directive';
import { FieldsComponent } from '../../fields/fields.component';
import { FileViewComponent } from '../../../../sb-modules/Frontend-Document-Viewer-Module/components/file-view/file-view.component';
import { FilePreviewComponent } from '../../../../sb-modules/Frontend-Document-Viewer-Module/components/file-preview/file-preview.component';
import { IntegrationBlockComponent } from '../../integration-block/integration-block.component';
import { TicketEmailTimePipe } from '../../../../sb-tools/typescript/pipes/ticket/ticket-email-time.pipe';
import { ReplaceEmojisPipe } from '../../../../sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';
import { PrepareMessagePipe } from '../../../../sb-tools/typescript/pipes/ticket/prepare-message.pipe';
import { JoinPipe } from '../../../../sb-tools/typescript/pipes/join.pipe';
import { TimeAgoPipe } from '../../../shared/pipes/time-ago.pipe';
import { HideContentPipe } from '../../../shared/pipes/hide-content.pipe';
import { DetailedTicketDTO } from '../../../core/models/dto/detailed-ticket.dto';
import { isInboxElementVisible } from '../../../core/utils/is-inbox-element-visible.util';

@Component({
    selector: 'app-ticket-main-message',
    templateUrl: './ticket-main-message.component.html',
    styleUrls: ['./ticket-main-message.component.scss'],
    imports: [
        NgClass,
        UserAvatarComponent,
        TooltipModule,
        BsDropdownModule,
        InlineSVGComponent,
        TranslateModule,
        PopoverModule,
        InlineImagePreviewDirective,
        InlineImageLimitWidthDirective,
        FieldsComponent,
        FileViewComponent,
        FilePreviewComponent,
        IntegrationBlockComponent,
        DatePipe,
        TicketEmailTimePipe,
        ReplaceEmojisPipe,
        PrepareMessagePipe,
        JoinPipe,
        TimeAgoPipe,
        HideContentPipe,
    ],
})
export class TicketMainMessageComponent implements OnInit, OnDestroy {
    @Input() ticket: DetailedTicketDTO;

    ccEmails = [];
    forwardEntityTypeEnum = ForwardEntityTypeEnum;
    isLoadingOriginalMessage: boolean;
    // todo: remove when postnord start using chat view
    isToAndCcHidden: boolean;
    originalMessage: MessageDTO;
    rightPanelTypeEnum = RightPanelType;
    ticketSourceEnum = TicketSource;
    readonly isInboxElementVisible = isInboxElementVisible;

    private unsubscriber = new Subject<void>();

    constructor(
        public rightPanelService: RightPanelService,
        public commonDataService: CommonDataService,
        private ticketService: TicketService,
        public forwardMessageService: ForwardMessageService,
        private translateService: TranslateService,
        private notificationsService: NotificationsService,
    ) {
        this.isToAndCcHidden = ['postnordsverige', 'postnordsetest', 'nataliatestdev', 'nataliafirsttest'].includes(
            commonDataService.community?.toLowerCase(),
        );
    }

    ngOnInit() {
        this.ccEmails = structuredClone(this.ticket.ccEmails);
    }

    deleteHiddenContent(): void {
        this.ticketService
            .deleteHiddenContent(this.ticket.id, null)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((hideContent: HideContentPartResponseDTO) => {
                this.ticket.hasContentPartHiddenForClient = hideContent.hasContentPartHiddenForClient;
                this.ticket.isContentHiddenForClient = hideContent.isContentHiddenForClient;
                this.ticket.message = hideContent.message;

                this.notificationsService.success(
                    this.translateService.instant('Success!'),
                    this.translateService.instant('The content was successfully showed.'),
                );
            });
    }

    openHideContentPanel(): void {
        const selectedText = window.getSelection().toString().trim();
        this.rightPanelService.open(RightPanelType.hideTicketContent, {
            ticket: this.ticket,
            replyId: null,
            hidingText: selectedText,
        });
    }

    showOriginalMessage(ticketId: number) {
        const newWindow = window.open();
        if (!this.originalMessage && !this.isLoadingOriginalMessage) {
            this.isLoadingOriginalMessage = true;
            this.ticketService
                .getOriginalMessage(ticketId)
                .pipe(takeUntil(this.unsubscriber))
                .subscribe((result: MessageDTO) => {
                    this.originalMessage = result;
                    this.isLoadingOriginalMessage = false;
                    newWindow.document.write(result.html || result.text);
                });
            return;
        }

        newWindow.document.write(this.originalMessage.html || this.originalMessage.text);
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
